import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import APIs, { ServicesApi } from "../apis";
import useAuth from "./auth";
import useApi from "./api";

const usePayment = () => {
  const element = useElements();
  const { execute } = useApi();
  const stripe = useStripe();
  const { user } = useAuth();

  const cardSetup = async ({
    serviceUuid = "",
    serviceName = "",
    servicePaymentPlan = "",
    successDelay = 3000,
  } = {}) => {
    const { secret } = await execute(async () =>
      ServicesApi.subscriptionIntent(serviceUuid, {
        service: serviceName,
        name: servicePaymentPlan,
      })
    );
    const card = element.getElement(CardElement);
    const { error } = await stripe.confirmCardSetup(secret, {
      payment_method: {
        card,
        billing_details: { name: user.alias },
      },
    });
    if (!!error) throw { message: error.message };
    await new Promise((resolve) => setTimeout(() => resolve(), successDelay));
  };

  const checkout = async (props) => {
    const { sessionId } = await execute(() =>
      APIs.subscriptions.checkout(props)
    );
    stripe.redirectToCheckout({ sessionId });
    await new Promise((resolve) => setTimeout(resolve, 200)); //adding 200ms await to avoid awkward ui
  };

  return { cardSetup, checkout };
};

export default usePayment;
